import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';


@Component({
    selector: 'input-text-clipboard',
    templateUrl: './input-text-clipboard.component.html',
    styleUrls: ['./input-text-clipboard.component.scss']
})
export class InputTextClipboardComponent extends TwoWayBoundComponent<string> {

    @Input()
    public label: string;

    @ViewChild('InputTextField')
    public inputTextField: ElementRef | undefined;

    constructor() {
        super();
    }

    public copy(): void {
        if (this.inputTextField && this.inputTextField.nativeElement) {
            this.inputTextField.nativeElement.select();
            this.inputTextField.nativeElement.setSelectionRange(0, 99);
            document.execCommand('copy');
        }
    }
}
